export default {
  methods: {
    setCustomHeaderSort(headerValue) {
      const urlQuerySortBy = this.$route?.query?.sortBy;
      if (urlQuerySortBy) {
        this.customHeaderSort = this.parseUrlSort(urlQuerySortBy);
      } else {
        this.customHeaderSort = {
          value: headerValue,
          columnDescending: false,
          clearSort: false
        };
      }
    },
    parseUrlSort(urlQuerySortBy) {
      let urlJsonSortBy;
      try {
        urlJsonSortBy = JSON.parse(urlQuerySortBy);
      } catch {
        return { values: [], clearSort: true };
      }
      if (!urlJsonSortBy || typeof urlJsonSortBy !== "object") {
        return { values: [], clearSort: true };
      }
      if (Array.isArray(urlJsonSortBy.sortBy)) {
        const sortDesc = Array.isArray(urlJsonSortBy.sortDesc)
          ? urlJsonSortBy.sortDesc
          : [];
        return {
          values: urlJsonSortBy.sortBy.map((value, index) => ({
            value,
            desc: !!sortDesc[index]
          })),
          clearSort: false
        };
      }
      if (typeof urlJsonSortBy.sortBy === "undefined") {
        return { values: [], clearSort: true };
      }
      return {
        value: urlJsonSortBy.sortBy,
        columnDescending: urlJsonSortBy.sortDesc,
        clearSort: false
      };
    }
  }
};
